import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConnectionService } from './connection.service';
import { ConfigService } from './endpoint.config.service';


@Injectable({
  providedIn: 'root'
})
export class AddEditUserService extends ConnectionService {

  constructor(http: HttpClient, private configs: ConfigService) {
    super(http);
  }
  searchSysUsers(locationId, searchTerm, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("REFERENCE_DATA_PERSONS").replace('{{currentLocationId}}', currentLocationId);
    this.CallApi("get", endPoint, { startsWith: searchTerm, take: 10, skip: 0 }, null, (res) => {
      var resp = JSON.parse(JSON.stringify(res.Results))
      sucFun(resp)
    }, (err) => { errFun(err) });
  }
  getDefaultSettings(sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("DEFAULT_SETTINGS").replace('{{currentLocationId}}', currentLocationId);
    this.CallApi("get", endPoint, '', null, (res) => {
      var resp = JSON.parse(JSON.stringify(res))
      sucFun(resp)
    }, (err) => { errFun(err) });
  }
  isUserExists(locationId, sucFun, errFun, param) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("IS_USER_EXIST").replace('{{currentLocationId}}', currentLocationId);
    this.CallApi("get", endPoint, param, null, (resp) => {
      sucFun(resp)
    },
      (err) => {
        try {
          errFun(err.error[0])
        }
        finally {

        }

      })
  }
  removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }
  getReports(sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("GET_REPORT").replace('{{currentLocationId}}', currentLocationId);
    this.CallApi("get", endPoint, {}, null, (res) => {
      var resp = JSON.parse(JSON.stringify(res)) as any[]
//alert(currentLocationId)
console.log("getReports response=", res);

      var reportType = [];
      var resolvedReportType = [];
      resp.forEach((item, i) => {
        reportType.push(resp.filter(x => x.Type.ReportTypeId == item.Type.ReportTypeId));
      })
      reportType.forEach((item, i) => {
        var report = item as any[];
        var tempReport = []
        report.filter((x) => {
          if (item[0].Type.ReportTypeId == x.Type.ReportTypeId) {
            tempReport.push({ "ReportId": x.ReportId, "Code": x.Code, "Description": x.Description })
          }
        })
        resolvedReportType.push({
          reportTypeId: item[0].Type.ReportTypeId,
          reportDescription: item[0].Type.Description,
          reports: tempReport
        })
      });
      sucFun(this.removeDuplicates(resolvedReportType, 'reportTypeId'));

    }, (err) => {
      errFun(err)
    })

  }
  getAccounts(serachTerm, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("GET_ACCOUNTS").replace('{{currentLocationId}}', currentLocationId);
    this.CallApi("get", endPoint, { accountStartsWith: serachTerm }, null, (res) => {
      var resp = JSON.parse(JSON.stringify(res))
      sucFun(resp)
    }, (err) => { errFun(err) });
  }
  addUser(user, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("ADD_USER").replace('{{currentLocationId}}', currentLocationId)
    this.CallApi("post", endPoint, user, null, (res) => {
      sucFun(res);
    }, (err) => {
      errFun(err);
    });
  }
  updateUser(userId, user, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("UPDATE_USER").replace('{{currentLocationId}}', currentLocationId).replace('{{currentLocationId}}', userId)
    this.CallApi("put", endPoint, user, null, (res) => {
      sucFun(res);
    }, (err) => {
      try {
        errFun(err);
      }
      finally { }
    });
  }
  getPaymentDevices(request, sucFun, errFun) {
    var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
    var endPoint = this.configs.getAppApiUrl("GET_PAYMENT_DEVICES").replace('{{currentLocationId}}', currentLocationId);
    // That's means get All devices because the endpoint returns all devices at all or returns device by device code.
    if (request != 'All')
      endPoint = endPoint + '/' + request;
    this.CallApi("get", endPoint, {}, null, (res) => {
      sucFun(res);
    }, (err) => { errFun(err) });

  }
}
